export default class FulfillmentOrderInfo {
    /** 상점 아이디 */
    storeId = '';
    /** 주문 아이디 */
    orderId = '';
    /** 주문 상태 */
    statusCode = null;
    deliveryStatus;
    /** 총판 아이디 */
    distributorId = '';
    /** 허브 아이디 */
    hubId = '';
    /** 파트너 아이디 */
    partnerOrderId = '';
    /** 픽업 예정 시간 */
    pickupExpectedAt = '';
    /** 도착지 좌표 */
    dropLocation = null;
    /** 출발지 좌표 */
    pickupLocation = null;
    constructor(data) {
        Object.assign(this, data);
    }
    // eslint-disable-next-line class-methods-use-this
    get getDropLocation() {
        return '123123';
    }
    // eslint-disable-next-line class-methods-use-this
    get getPickupLocation() {
        return '123123';
    }
}
